export default __webpack_public_path__ + "static/SRUS P300 - Product Specifications & Technical Data-9f960ac3faa5a25b31dc5f6f233944c6.pdf";